<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" id="publishers-note">
<h1 class="hidden" data-number="1">Publisher’s Note</h1>
<p>This book contains views and language on nationality, sexual politics, ethnicity, and society which are a product of the time in which the book is set. The publisher does not endorse or support these views. They have been retained in order to preserve the integrity of the text.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f8fd5372